import { useMemo } from 'react';

import { GainAccessView } from '../../components/GainAccessView';
import type { LockVariant } from '../../domain/gainAccessView';
import { EMPTY_QUOTA, isOutOfQuota } from '../../domain/quota';
import { USER_SAM_ON_BOARDING_COMPLETED } from '../../domain/user';
import { GENERATE_EMAIL_QUERY_KEY } from '../../features/insights/insightsQueryKey';
import { useEmailsQuotaQuery } from '../../features/insights/useEmailsQuotaQuery';
import { useUserQuery } from '../../features/user/useUserQuery';
import { useUserStatus } from '../../hooks/useUserStatus';
import { queryClient } from '../../queryClient';

import { InsightsView } from './InsightsView';
import { OnboardingView } from './OnboardingView';

export const InsightsContainer = () => {
  const { data } = useUserQuery();

  const emailsQuota = useEmailsQuotaQuery()?.data ?? EMPTY_QUOTA;
  const emailsData = queryClient.getQueriesData({
    queryKey: [GENERATE_EMAIL_QUERY_KEY],
  });

  const isEmailsQuotaExceeded = useMemo(() => isOutOfQuota(emailsQuota), [emailsQuota]);
  const { isTrial, isAfterTrial } = useUserStatus();

  if (isEmailsQuotaExceeded && (!emailsData || emailsData.length === 0)) {
    let variant: LockVariant = 'insights-limit-reached-paid';
    if (isTrial) {
      variant = 'insights-limit-reached-trial';
    } else if (isAfterTrial) {
      variant = 'insights-limit-reached-after-trial';
    }
    return <GainAccessView variant={variant} />;
  }

  if (!data?.userSettings?.[USER_SAM_ON_BOARDING_COMPLETED]) {
    return <OnboardingView />;
  }

  return <InsightsView />;
};
